import ReportTable from './report-table'
import ReportTableHandler from '../../handlers/report-table'

const builtReportTables = []

function teardownReportTables() {
  builtReportTables.forEach((reportTable) => {
    reportTable.teardown()
  })
  builtReportTables.length = 0
}

function initReportTables() {
  document
    .querySelectorAll('table[data-behaviour="report-table"]')
    .forEach(function (el) {
      builtReportTables.push(new ReportTable(el))
    })

  const handler = new ReportTableHandler($(document))
  handler.restoreReportSettings()
}

function onTurbolinksLoad() {
  const renderedTable = document.querySelector(
    "table[data-behaviour='report-table']"
  )
  if (renderedTable) {
    initReportTables()
  }
}

// Anything that replaces the table has to call this: the built ReportTable
// instances are bound to the element that just went away, and the collapsed and
// expanded rows the user chose live in local storage, so they are only back on
// screen once restoreReportSettings has run against the new table.
//
// The turbo:frame-load path below is the same thing for the frame reloading
// itself; the inline column editor calls it directly after swapping in a table
// it rendered (see reports/column_editor_controller), because the report is not
// always inside the frame — with `render=1` in the URL, reports#show renders the
// table on the page itself.
export function reinitReportTables() {
  teardownReportTables()
  initReportTables()
}

function onFrameLoad(event) {
  if (event.target?.id !== 'report-table') return
  reinitReportTables()
}

document.addEventListener('turbolinks:load', onTurbolinksLoad)
document.addEventListener('turbolinks:before-visit', teardownReportTables)
document.addEventListener('turbo:frame-load', onFrameLoad)
